import PathSpine from '../components/PathSpine.jsx';
import PathStage from '../components/PathStage.jsx';
import Reveal from '../shared/Reveal.jsx';
import { useStages } from '../content/useContent.js';

export default function Path() {
  const stages = useStages();

  return (
    <section id="programs" className="relative bg-cream pb-15 pt-24">
      <div className="mx-auto max-w-[1240px] px-5 sm:px-8">
        <Reveal className="max-w-[720px]">
          <p className="font-hand text-2xl text-coral">The path through our school</p>
          <h2 className="mt-1.5 font-display text-[clamp(30px,4vw,54px)] font-extrabold leading-[1.02] text-forest">
            Three stages. Fourteen years.
            <br />
            One long walk together.
          </h2>
          <p className="mt-4 text-pretty text-lg leading-[1.6] text-ink-soft">
            A child who joins our Toddler room at two will be taught by some of the same
            faces at sixteen. Here is exactly what each stage looks like, day to day.
          </p>
        </Reveal>

        <div className="relative mt-[62px]">
          <PathSpine />
          {stages.map((stage, i) => (
            <PathStage key={stage.id} stage={stage} last={i === stages.length - 1} />
          ))}
        </div>
      </div>
    </section>
  );
}
